import React from "react";
import { connect } from "react-redux";

import Families from "./Families";

const FamiliesContainer = props => {
  return <Families {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(FamiliesContainer);



// WEBPACK FOOTER //
// src/containers/metier/referential/Families.container.js